import React from 'react';
import styled from 'styled-components';
import { AppModal } from '../../../../../generic/ui/Modal';
import ScanBar from '../../../../../generic/ui/Input/ScanBar';
import KbdChipButton from '../../../../../generic/ui/KbdChipButton/KbdChipButton';
import PrintIcon from '../../../../../generic/icons/IconLib/PrintIcon';
import { PdfPreview } from '../../../../../generic/ui/PdfPreview';
import RemarkModal from '../../arizot/View/RemarkModal';
import CheckPalletPageLayout from './Components/CheckPalletPageLayout';
import CheckPalletScrollArea from './Components/CheckPalletScrollArea';
import CheckPalletActionDock from './Components/CheckPalletActionDock';
import CheckPalletRow from './Components/CheckPalletRow';
import useCheckPallet from './services/hooks/useCheckPallet';

export default function LikutExpressCheckPalletMain() {
    const c = useCheckPallet();

    return (
        <CheckPalletPageLayout title='ביקורת משטח'>
            {c.isOpenRemark && (
                <AppModal
                    title='הערת ביקורת משטח'
                    Children={RemarkModal}
                    childrenProps={c.remarkProps}
                    controlFunc={c.closeRemark}
                />
            )}

            {c.file && (
                <AppModal
                    size='lg'
                    title='תצוגה מקדימה'
                    controlFunc={c.handleClearFile}
                    Children={PdfPreview}
                    childrenProps={{
                        file: c.file,
                        handleSharePdf: c.handleSharePdf,
                        handleDownloadPdf: c.handleDownloadPdf,
                        handleClearFile: c.handleClearFile,
                        handleOpenPdf: c.handleOpenPdf,
                    }}
                />
            )}

            <CheckPalletScrollArea
                stickyHeader={
                    <ScanRow>
                        <ScanSlot>
                            <ScanBar onScan={c.loadPallet} placeholder='מספר משטח' />
                        </ScanSlot>
                        {c.rows != null && (
                            <KbdChipButton onClick={c.handlePrint} aria-label='הדפסה' title='הדפסה'>
                                <PrintIcon size={16} color='currentColor' />
                            </KbdChipButton>
                        )}
                    </ScanRow>
                }
            >
                {c.rows?.map((row, i) => (
                    <CheckPalletRow
                        key={row.RecID}
                        item={row}
                        isLast={i === c.rows!.length - 1}
                        onRemark={c.openRemark}
                    />
                ))}
            </CheckPalletScrollArea>

            <CheckPalletActionDock onSave={c.saveComments} canSave={c.canSave} />
        </CheckPalletPageLayout>
    );
}

const ScanRow = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    gap: 0.5rem;

    & > button {
        flex-shrink: 0;
    }
`;

const ScanSlot = styled.div`
    flex: 1;
    min-width: 0;
`;
